<div class="ot-panel__header">
  <app-tabs [identifier]="'user-form-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
    [color]="TabColor.PRIMARY" [selectedIndex]="currentTab"></app-tabs>
</div>
<form [formGroup]="userForm" name="otsc-user-form" [attr.data-userform-type]="type"
  [ngStyle]="{'height': formHeight, 'width': '100%'}">
  <ng-scrollbar>
    <div class="ot-mb-1 ot-mt-1 ot-ml-1 ot-mr-1" [ngClass]="{'d-none': currentTab !== UserFormTab.GENERAL}">
      @if (userForm.invalid && userRoleCtrl.touched && userRoleCtrl.invalid) {
      <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            No permissions are assigned. Please select a role to assign a permission.
          </p>
        </div>
      </div>
      }
      @if (userRoleCtrl.touched && userRoleCtrl.valid && ((userRoleCtrl.value === 'SolutionManager' &&
      solManagerSelectedSolutions.length == 0) || (userRoleCtrl.value === 'EnvironmentManager') &&
      envManagerSelectedEnvironments.length == 0)) {
      <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            No permissions are assigned. Switch to Permissions tab to assign the permissions.
          </p>
        </div>
      </div>
      }
      <div class="ot-row">
        @if (type == UserFormType.OTDS && mode === UserFormMode.ADD) {
        <div class="ot-row__column ot-row__column--is-50">
          <div class="ot-form-control">
            <label for="otdsUsernameSearch" class="ot-form-control__label">
              <span i18n>Directory services user name</span>
            </label>
            <div class="ot-combo-box">
              <div class="ot-dropdown"
                [ngClass]="{'ot-dropdown--is-active': !isSearchingOTDSUser && OTDSUserNameCtrl.value && OTDSUserNameCtrl.value != ''}">
                <div class="ot-form-control">
                  <input id="otdsUsernameSearch" (focusin)="searchOTDSUsers(OTDSUserNameCtrl.value)"
                    placeholder="Search and select directory services user name" type="text" class="ot-input"
                    formControlName="OTDSUserNameCtrl" autocomplete="off">
                </div>
                <ul class="ot-dropdown__menu ot--is-width-100">
                  @for (otdsUser of OTDSUsers; track otdsUser) {
                  <li class="ot-dropdown__item otds-users-list" (click)="selectOTDSUser(otdsUser)">{{otdsUser.id}}
                    ({{otdsUser.givenName}} {{otdsUser.surname}})</li>
                  }
                  @if (!isSearchingOTDSUser && OTDSUserNameCtrl.value && OTDSUserNameCtrl.value != '' &&
                  OTDSUsers.length == 0) {
                  <li class="ot-dropdown__item otds-users-not-found" i18n>No results found</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <div class="ot-row">
        <div class="ot-row__column ot-mr-1">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : userNameCtrl.touched && userNameCtrl.invalid, 'ot-mb-0': type == UserFormType.OTDS}">
            <label for="userName" class="ot-form-control__label">
              @if (!userNameCtrl.disabled || this.type == UserFormType.OTDS) {
              <span class="ot-form-control--is-required">*</span>
              }
              <span i18n>Id</span>
            </label>
            <input id="userName" name="userName" [readonly]="type == UserFormType.OTDS" formControlName="userNameCtrl"
              [placeholder]="type == UserFormType.OTDS ? 'Select directory services user name' : 'Enter user name (Email)'"
              type="text" [email]="isRequireEmailValidation" class="ot-input" maxlength="100">
            @if (userNameCtrl.invalid && userNameCtrl.errors.email && !userNameCtrl.errors?.pattern) {
            <p id="invalidUserNameErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
              User name is not a valid email.
            </p>
            }
            @if (userNameCtrl.touched && userNameCtrl.invalid && userNameCtrl.errors.required) {
            <p id="requiredUserNameErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
              User name cannot be empty.
            </p>
            }
            @if (userNameCtrl.errors && userNameCtrl.errors.usernameExists) {
            <p id="usernameExistsErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
              User name already exists.
            </p>
            }
            @if (userNameCtrl.dirty && userNameCtrl.errors?.pattern) {
            <p id="usernameInvalidCharactersErrorMsg" class="ot-form-control__error-text" i18n autocomplete="off">
              The user name contains invalid characters.
            </p>
            }
          </div>
        </div>
        <div class="ot-row__column">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : userRoleCtrl.touched && userRoleCtrl.invalid}">
            <label class="ot-form-control__label">
              @if (!userRoleCtrl.disabled) {
              <span class="ot-form-control--is-required">*</span>
              }
              <span i18n>Role</span>
            </label>
            <div class="ot-select">
              <select name="userRole" formControlName="userRoleCtrl" i18n-aria-label aria-label="Select user role"
                (change)="this.updateDataCtrlForm()">
                <option value="" i18n>
                  Select role
                </option>
                @for (option of roleOptions; track option) {
                <option [value]="option.value" [disabled]="option.disabled">
                  {{option.name}}
                </option>
                }
              </select>
            </div>
            @if (userRoleCtrl.touched && userRoleCtrl.invalid && userRoleCtrl.errors.required) {
            <p id="requiredUserRoleErrorMsg" class="ot-form-control__error-text" i18n>
              Role is required.
            </p>
            }
          </div>
        </div>
      </div>
      <div class="ot-row">
        <div class="ot-row__column ot-mr-1">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : givenNameCtrl.touched && givenNameCtrl.invalid}">
            <label class="ot-form-control__label" for="givenName" i18n>
              @if (!givenNameCtrl.disabled && type != UserFormType.OTDS) {
              <span class="ot-form-control--is-required">*</span>
              }
              Given name
            </label>
            <input id="givenName" name="givenName" [readonly]="type == UserFormType.OTDS"
              formControlName="givenNameCtrl"
              [placeholder]="type !== UserFormType.OTDS ? enterGivenNamePlaceholder : ''" type="text" class="ot-input"
              maxlength="50">
            @if (givenNameCtrl.touched && givenNameCtrl.errors && givenNameCtrl.errors.required) {
            <p id="givenNameRequiredErrorMsg" class="ot-form-control__error-text" i18n>
              Given name cannot be empty.
            </p>
            }
          </div>
        </div>
        <div class="ot-row__column">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : surNameCtrl.touched && surNameCtrl.invalid}">
            <label class="ot-form-control__label" for="surName" i18n>
              @if (!surNameCtrl.disabled && type != UserFormType.OTDS) {
              <span class="ot-form-control--is-required">*</span>
              }
              Surname
            </label>
            <input id="surName" name="surName" [readonly]="type == UserFormType.OTDS" formControlName="surNameCtrl"
              [placeholder]="type !== UserFormType.OTDS ? enterSurnamePlaceholder : ''" type="text" class="ot-input"
              maxlength="50">
            @if (surNameCtrl.touched && surNameCtrl.errors && surNameCtrl.errors.required) {
            <p id="surNameRequiredErrorMsg" class="ot-form-control__error-text" i18n>
              Surname cannot be empty.
            </p>
            }
          </div>
        </div>
      </div>
      @if (type == UserFormType.LOCAL) {
      <div class="ot-row">
        <div class="ot-row__column ot-mr-1">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : newPasswordCtrl.touched && newPasswordCtrl.invalid}">
            <label class="ot-form-control__label" for="newPassword">
              @if (mode === UserFormMode.ADD) {
              <span class="ot-form-control--is-required">*</span>
              }
              <span i18n>Password</span>
            </label>
            <input id="newPassword" name="newPassword" formControlName="newPasswordCtrl" i18n-placeholder
              placeholder="Enter new password" type="password" class="ot-input" autocomplete="off" maxlength="44">
            @if (newPasswordCtrl.errors && newPasswordCtrl.errors.passwordValidationFailed &&
            newPasswordCtrl.errors.passwordValidationType === 'passwordValidationErrorPwdLength') {
            <p id="passwordLengthErrorMsg" class="ot-form-control__error-text" i18n>
              Password field must be at least eight characters in length.
            </p>
            }
            @if (newPasswordCtrl.errors && newPasswordCtrl.errors.passwordValidationFailed &&
            newPasswordCtrl.errors.passwordValidationType === 'passwordValidationErrorPwdLetter') {
            <p id="passwordMissingLetterErrorMsg" class="ot-form-control__error-text" i18n>
              Password field must contain at least one alphabetical character.
            </p>
            }
            @if (newPasswordCtrl.errors && newPasswordCtrl.errors.passwordValidationFailed &&
            newPasswordCtrl.errors.passwordValidationType === 'passwordValidationErrorPwdDigit') {
            <p id="passwordMissingDigitErrorMsg" class="ot-form-control__error-text" i18n>
              Password field must contain at least one numeric digit.
            </p>
            }
            @if (newPasswordCtrl.touched && newPasswordCtrl.errors && newPasswordCtrl.errors.required) {
            <p id="passwordrequiredErrorMsg" class="ot-form-control__error-text" i18n>
              Password cannot be empty.
            </p>
            }
          </div>
        </div>
        <div class="ot-row__column">
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : confirmNewPasswordCtrl.touched && userForm.invalid && userForm.errors && userForm.errors.passwordNotSame}">
            <label class="ot-form-control__label" for="confirmNewPassword">
              @if (mode === UserFormMode.ADD) {
              <span class="ot-form-control--is-required">*</span>
              }
              <span i18n>Confirm Password</span>
            </label>
            <input id="confirmNewPassword" name="confirmNewPassword" formControlName="confirmNewPasswordCtrl"
              i18n-placeholder placeholder="Enter new confirm password" type="password" class="ot-input"
              autocomplete="off" maxlength="44">
            <p id="passwordDoNotMatchErrorMsg" class="ot-form-control__error-text" i18n>These passwords do not match.
            </p>
          </div>
        </div>
      </div>
      }
    </div>
    @if (currentTab == UserFormTab.PERMISSIONS) {
    <div class="ot-p-1">
      @if (!userRoleCtrl.invalid) {
      <div>
        <div>
          @switch (userRoleCtrl.value) {
          @case (UserRole.SUPERUSER.toString()) {
          <div>
            <div class="ot-message ot-message--is-info">
              <div class="ot-message__banner">
                <p class="title" i18n id="otsc-user-form-su-perm-msg">
                  Administrator users have access to all solutions and environments.
                </p>
              </div>
            </div>
          </div>
          }
          @case (UserRole.ADMINSTRATOR.toString()) {
          <div>
            <div class="ot-message ot-message--is-info">
              <div class="ot-message__banner">
                <p class="title" i18n id="otsc-user-form-admin-perm-msg">
                  Administrator users have access to all solutions and environments.
                </p>
              </div>
            </div>
          </div>
          }
          @case (UserRole.SOLUTION_MANAGER.toString()) {
          <div class="ot-table" id="otsc-user-form-sol-mgr-perm">
            <app-datatable [identifier]="'user-permission-table'" [isloading]="isLoadingPerm"
              [title]="solManagerPermTableTitle" [cols]="solManagerPermTableCols"
              [pagination]="solManagerPermTablePagination" [showcheckboxes]="solManagerPermShowcheckboxes"
              [rows]="solManagerPermTableRows" [total]="solManagerPermTableTotal"
              (checkboxchangeevent)="solutionRowClicked($event)"
              (selectAllClickEvent)="solutionSelectAllRowClicked($event)" [scroll]="false"></app-datatable>
          </div>
          }
          @case (UserRole.ENVIRONMENT_MANAGER.toString()) {
          <div class="ot-table" id="otsc-user-form-env-mgr-perm">
            <app-datatable [identifier]="'user-permission-table'" [isloading]="isLoadingPerm"
              [title]="envManagerPermTableTitle" [cols]="envManagerPermTableCols"
              [pagination]="envManagerPermTablePagination" [showcheckboxes]="envManagerPermShowcheckboxes"
              [rows]="envManagerPermTableRows" [total]="envManagerPermTableTotal"
              (checkboxchangeevent)="environmentRowClicked($event)"
              (selectAllClickEvent)="environmentSelectAllRowClicked($event)" [scroll]="false"></app-datatable>
          </div>
          }
          }
        </div>
      </div>
      }
      @if (userRoleCtrl.invalid) {
      <div>
        <div class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="title" i18n>
              No permissions are assigned. Please select a role to assign a permission.
            </p>
          </div>
        </div>
      </div>
      }
    </div>
    }
  </ng-scrollbar>
</form>